import { Component, useState, type ReactNode } from 'react'
import { Canvas } from '@react-three/fiber'
class FalhaCena extends Component<{ children: ReactNode }, { falhou: boolean }> {
  state = { falhou: false }
  static getDerivedStateFromError() { return { falhou: true } }
  render() { return this.state.falhou ? <p className="qi-sem-webgl" role="status">A visualização 3D não está disponível. Os controles e as explicações continuam acessíveis.</p> : this.props.children }
}
export function ViewportDidatico3D({ children, posicao }: { children: ReactNode; posicao: [number, number, number] }) {
  const [disponivel] = useState(() => {
    if (typeof document === 'undefined') return false
    try {
      const contexto = document.createElement('canvas').getContext('webgl2')
      contexto?.getExtension('WEBGL_lose_context')?.loseContext()
      return Boolean(contexto)
    } catch { return false }
  })
  if (!disponivel) return <p className="qi-sem-webgl" role="status">A visão 3D exige WebGL 2 neste navegador. Você pode usar os controles, comparar configurações e explorar as explicações.</p>
  return <FalhaCena><Canvas dpr={[1, 1.5]} frameloop="demand" camera={{ position: posicao, fov: 40 }} gl={{ antialias: true }}>
    {children}
  </Canvas></FalhaCena>
}
